'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

Object.defineProperty(exports, '__esModule', {
  value: true
});
exports['default'] = memoize;
/**
 * @copyright 2015, Andrey Popp <8mayday@gmail.com>
 */

var SENTINEL = {};

function memoize(target, name, descriptor) {
  if (typeof descriptor.value === 'function') {
    return _memoizeMethod(target, name, descriptor);
  } else if (typeof descriptor.get === 'function') {
    return _memoizeGetter(target, name, descriptor);
  } else {
    throw new Error('@memoize decorator can be applied to methods or getters, got ' + String(descriptor.value) + ' instead');
  }
}

function _memoizeGetter(target, name, descriptor) {
  var memoizedName = '_memoized_' + name;
  var get = descriptor.get;
  target[memoizedName] = SENTINEL;
  return _extends({}, descriptor, {
    get: (function (_get) {
      function get() {
        return _get.apply(this, arguments);
      }

      get.toString = function () {
        return _get.toString();
      };

      return get;
    })(function () {
      if (this[memoizedName] === SENTINEL) {
        this[memoizedName] = get.call(this);
      }
      return this[memoizedName];
    })
  });
}

function _memoizeMethod(target, name, descriptor) {
  if (descriptor.value.length > 0) {
    throw new Error('@memoize decorator can only be applied to methods of zero arguments');
  }
  var memoizedName = '_memoized_' + name;
  var value = descriptor.value;
  target[memoizedName] = SENTINEL;
  return _extends({}, descriptor, {
    value: (function (_value) {
      function value() {
        return _value.apply(this, arguments);
      }

      value.toString = function () {
        return _value.toString();
      };

      return value;
    })(function () {
      if (this[memoizedName] === SENTINEL) {
        this[memoizedName] = value.call(this);
      }
      return this[memoizedName];
    })
  });
}
module.exports = exports['default'];
